const CLIPLISTER_JS_URL = 'https://mycliplister.com/merge?cliplister=1.11&clviewer=1.41&videostage=1.27&hls=1.0&videostagehls=1.2&innercontrols=1.14&clickablevideo=1.5&playbutton=1.2&previewimage=1.6&bufferingspinner=1.5';
const CUSTOMER_ID = 187751;

export default class CliplisterVideo {

  constructor(){
    window.console.log("CliplisterVideo erzeugt");
  }

  initForNode(videoNode) {
    if (!window.Cliplister) {
      this.loadJSAndInit(videoNode);
    } else {
      this.init(videoNode);
    }
  }

  loadJSAndInit(videoNode) {
    const scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.src = CLIPLISTER_JS_URL;
    scriptElement.onload = () => {
      this.init(videoNode);
    }
    document.body.appendChild(scriptElement);
  }

  init(videoNode) {
    const videoId = videoNode.dataset.videoId;
    const videoIndex = videoNode.dataset.videoIndex;
    const startbildUrl = videoNode.dataset.startbild;
    const assetsBaseUri = videoNode.dataset.assetsFolder;
    const controlsFilename = videoNode.dataset.hochformat === 'true' ? "controls-hochkant.html" : "controls.html";
    const controlsSource = `${assetsBaseUri}/skin/` + `${controlsFilename}`;

    const previewImageConfig = { layer: 6, backgroundSize: "contain" };
    if (startbildUrl) {
      previewImageConfig.image = startbildUrl;
    }
    const config = {
      parentId: `viewer-${videoIndex}`,
      customer: CUSTOMER_ID,
      languages: ["##"],
      assets: [videoId],
      keyType: 30000,
      fsk: 18,
      stage: { },
      plugins: {
        InnerControls: {
          layer: 2,
          id: "controls",
          blacklist: ["share", "playback-speed"],
          template: {
            type: "external",
            source: `${controlsSource}`
          }
        },
        ClickableVideo: { layer: 1 },
        BufferingSpinner: { layer: 3, width: 50, height: 50 },
        PlayButton: {
          id: "playButton",
          layer: 7,
          image: `${assetsBaseUri}/playButton.png`,
          width: 100,
          height: 100
        },
        PreviewImage: previewImageConfig
      }

    };
    const cliplisterBrandChannelVideo = new Cliplister.Viewer(config);
  }
}
